var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-count-down"},[_c('div',{staticClass:"content"},[_vm._t("default",null,null,{
        d: _vm.days,
        h: _vm.hours,
        m: _vm.mins,
        s: _vm.seconds,
        hh: ("00" + _vm.hours).slice(-2),
        mm: ("00" + _vm.mins).slice(-2),
        ss: ("00" + _vm.seconds).slice(-2),
      }),_vm._v("\n    asdfasfsadfsdafsdf\n  ")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fc30a5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CountDown.vue
// module id = null
// module chunks = 